export class CouponsModel {
  constructor() {
    this.couponName = '';
    this.description = '';
    this.percentage = true;
    this.expired = false;
    this.amount = '';
    this.featured = true;
    this.applicableForEntireCourse = true;
    this.unlimited = false;
    this.applicableFrom = '';
    this.applicableUpto = '';
    this.applicableForAnyStudent = true;
    this.studentMobile = '';
    this.createdBy = null;
    this.description = '';
    this.usageLimit = true;
    this.limit = '';
    this.storeListingInfoList = [];
    this.studentCouponMobileList = [];
    this.subjectInfoList = [];
  }
}

export class StudentMobileListModel {
  constructor() {
    this.applied = false;
    this.mobile = '';
  }
}
